<script lang="ts" setup>

  const isExpanded = ref(false)
  const paragraphHeight = ref('0px')

  const paragraphEl = useTemplateRef('paragraphEl')

  function toggleExpansion(): void {
    isExpanded.value = !isExpanded.value

    paragraphHeight.value = `${isExpanded.value ? paragraphEl.value?.clientHeight ?? 0 : 0}px`
  }

</script>

<template>
  <div class="c-expansion-panel">
    <p
      class="question"
      :class="{ active: isExpanded }"
      @click="toggleExpansion"
    >
      <span><slot name="question" /></span>
    </p>
    <p
      :style="{ height: `${paragraphHeight}` }"
      class="answer"
    >
      <span ref="paragraphEl"><slot name="answer" /></span>
    </p>
  </div>
</template>

<style scoped>

.c-expansion-panel {
  position: relative;
  background-color: white;

  &:first-of-type {
    .question {
      border-top: solid 1px var(--color-secondary-light);
    }
  }

  .question {
    padding: 1em 1.5em;
    border-bottom: solid 1px var(--color-secondary-light);
    cursor: pointer;
    transition: all 0.3s ease;
    user-select: none;

    span {
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 1em;
      font-weight: 600;
      opacity: 0.8;
      transition: all 0.3s ease;
    }

    &.active {
      border-top-color: var(--color-secondary);
      background-color: var(--color-secondary);

      span {
        color: white;
        opacity: 1;
      }
    }
  }

  .answer {
    position: relative;
    overflow: hidden;
    height: 0;
    background-color: var(--color-secondary-light);
    transition: height 0.3s ease, opacity 0.3s ease;

    > span {
      position: relative;
      display: flex;
      padding: 1.5em;
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 0.875em;
      font-weight: normal;
      line-height: 1.5;
    }
  }
}
</style>
